import React from "react";
import PropTypes from "prop-types";
import { useField } from "formik";
import { Icon, Tooltip, useBreakpoints } from "@qgiv/core-react";
import {
    FormikCheckbox,
    MoreInfoModal,
    CheckboxWithTooltip,
    useHover,
} from "@qgiv/core-donor";

const PrivacyOptions = ({
    sectionHeading,
    additionalText = "",
    displayPrivacyNameCheckboxLabel,
    displayPrivacyAmountCheckboxLabel,
    privacyNameTooltip,
    privacyAmountTooltip,
    displayPrivacyOptions = false,
}) => {
    const { isSmallScreen } = useBreakpoints();
    const isHoverable = useHover();
    const privacyDisplayAmountFormikProps = {
        name: "Privacy_Display_Amount",
        type: "checkbox",
    };
    let [{ onBlur, onChange, ...field }] = useField(
        privacyDisplayAmountFormikProps,
    );
    const privacyDisplayAmountFieldProps = {
        handleBlur: onBlur,
        handleChange: onChange,
        ...field,
    };
    const privacyDisplayNameFormikProps = {
        name: "Privacy_Display_Name",
        type: "checkbox",
    };
    [{ onBlur, onChange, ...field }] = useField(privacyDisplayNameFormikProps);
    const privacyDisplayNameFieldProps = {
        handleBlur: onBlur,
        handleChange: onChange,
        ...field,
    };
    return (
        displayPrivacyOptions && (
            <div className="col col--12 -padding-top--30">
                <h3>{sectionHeading}</h3>
                {additionalText && <p>{additionalText}</p>}
                {isHoverable ? (
                    <>
                        <div className="col col--12 col--no-gutter -padding-top--10">
                            <FormikCheckbox
                                id="Privacy-Display-Name"
                                name="Privacy_Display_Name"
                                innerPadding={false}
                            >
                                {displayPrivacyNameCheckboxLabel}
                                {isSmallScreen ? (
                                    <span className="-padding-left--10">
                                        <MoreInfoModal>
                                            {privacyNameTooltip}
                                        </MoreInfoModal>
                                    </span>
                                ) : (
                                    <Tooltip
                                        placement="right"
                                        content={privacyNameTooltip}
                                        theme="dark"
                                    >
                                        <Icon
                                            className="-margin-left--5"
                                            glyph="question-circle-regular"
                                            type="FontAwesome"
                                        />
                                    </Tooltip>
                                )}
                            </FormikCheckbox>
                        </div>
                        <div className="col col--12 col--no-gutter">
                            <FormikCheckbox
                                id="Privacy-Display-Amount"
                                name="Privacy_Display_Amount"
                            >
                                {displayPrivacyAmountCheckboxLabel}
                                {isSmallScreen ? (
                                    <span className="-padding-left--10">
                                        <MoreInfoModal>
                                            {privacyAmountTooltip}
                                        </MoreInfoModal>
                                    </span>
                                ) : (
                                    <Tooltip
                                        placement="right"
                                        content={privacyAmountTooltip}
                                        theme="dark"
                                    >
                                        <Icon
                                            className="-margin-left--5"
                                            glyph="question-circle-regular"
                                            type="FontAwesome"
                                        />
                                    </Tooltip>
                                )}
                            </FormikCheckbox>
                        </div>
                    </>
                ) : (
                    <>
                        <CheckboxWithTooltip
                            name="Privacy_Display_Name"
                            id="Privacy-Display-Name"
                            label={displayPrivacyNameCheckboxLabel}
                            tooltipContent={privacyNameTooltip}
                            {...privacyDisplayNameFieldProps}
                        />
                        <CheckboxWithTooltip
                            name="Privacy_Display_Amount"
                            id="Privacy-Display-Amount"
                            label={displayPrivacyAmountCheckboxLabel}
                            tooltipContent={privacyAmountTooltip}
                            {...privacyDisplayAmountFieldProps}
                        />
                    </>
                )}
            </div>
        )
    );
};

PrivacyOptions.propTypes = {
    // section heading text
    sectionHeading: PropTypes.string.isRequired,
    // additional text below the heading
    additionalText: PropTypes.string,
    // privacy name checkbox label text
    displayPrivacyNameCheckboxLabel: PropTypes.string.isRequired,
    // privacy amount checkbox label text
    displayPrivacyAmountCheckboxLabel: PropTypes.string.isRequired,
    // tooltip text for the privacy name checkbox
    privacyNameTooltip: PropTypes.string.isRequired,
    // tooltip text for the privacy amount checkbox
    privacyAmountTooltip: PropTypes.string.isRequired,
    // for determining whether to show the privacy options or not
    displayPrivacyOptions: PropTypes.bool,
};

export default PrivacyOptions;
